export const Events = () => <h1 className="p-10 text-center">Events: Coming soon...</h1>
